import { createSelector } from 'reselect'
import {
  getGroupPaymentTotalAmount,
  getMyGroupPaymentContribution,
} from 'lib/payment/groupPaymentDetailsUtils'
import isGroupPaymentShareCheckout from './isGroupPaymentShareCheckout'

/**
 * Viewer's share for post-purchase group-payment-share checkout.
 * Derived from the order on the cart (same pattern as payment-schedule-balance reading schedule details).
 */
const getGroupPaymentShareContribution = createSelector(
  isGroupPaymentShareCheckout,
  (state: App.State) => state.checkout.cart.existingOrder?.groupPaymentDetails,
  (state: App.State) => state.auth.account.memberId,
  (isGroupPaymentShare, groupPaymentDetails, memberId): App.Checkout.GroupPaymentContributionPayment | undefined => {
    if (!isGroupPaymentShare || !groupPaymentDetails) {
      return undefined
    }

    const myContribution = getMyGroupPaymentContribution(groupPaymentDetails, memberId)
    if (!myContribution) {
      return undefined
    }

    return {
      contributionId: myContribution.id,
      amount: myContribution.amountRemaining,
      totalAmount: getGroupPaymentTotalAmount(groupPaymentDetails),
    }
  },
)

export default getGroupPaymentShareContribution
